import React from 'react';
import { Linkedin, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ color: '#059669' }}>
              Re-Surge
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Execution-led business rebuilding for founders and operators who want to build, fix, or scale real businesses.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Business Rebuild & Clarity Sprint</li>
              <li>Marketplace Strategy & Scale</li>
              <li>E-commerce & Brand Launch</li>
              <li>Fraud & Risk Advisory</li>
              <li>Founder Transition Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Email: resurgedevicesolutions@gmail.com</li>
              <li>Phone: +353 83 045 0305</li>
              <li>Location: Ireland</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2025 Re-Surge. Founded by Sean Gavin.</p>
        </div>
      </div>
    </footer>
  );
};